import React from "react";

const Breadcrumb = ({ items }) => {
    return (
        <div className="w-full  flex justify-center items-center p-4 xl:p-0 bg-[--color-button-1] h-16">
            <div className="w-[--page-width] flex justify-center items-center ">
                <nav className="text-sm text-gray-500 mb-4">
                    <ol className="flex flex-wrap items-center space-x-1">
                        {items?.map((item, index) => (
                            <li key={index} className="flex items-center">
                                {index > 0 && <span className="mx-1">/</span>}
                                {item.href ? (
                                    <a
                                        href={item.href}
                                        className=" hover:underline"
                                    >
                                        {item.label}
                                    </a>
                                ) : (
                                    <span className="text-gray-700">{item.label}</span>
                                )}
                            </li>
                        ))}
                    </ol>
                </nav>
            </div>
        </div>
    );
};

export default Breadcrumb;
